import {Component, computed, HostBinding, input} from '@angular/core';

@Component({
    selector: 'app-load',
    template: `
        @if (isLoading()) {
            <div
                [class]="containerClasses()"
                [style.width]="containerWidth()"
                [style.animation-duration.s]="duration()">
                <span [class]="spinnerClasses()" role="status"></span>
            </div>
        }
    `,
    styles: [
        `
            div {
                animation: fadein ease;
                animation-iteration-count: 1;
                animation-fill-mode: forwards;
            }

            @keyframes fadein {
                0% {
                    opacity: 0;
                }
                50% {
                    opacity: 0;
                }
                100% {
                    opacity: 1;
                }
            }
        `,
    ],
    standalone: true,
    imports: [],
})
export class LoadComponent {
    isLoading = input(true);
    fadeSpeed = input<'NORMAL' | 'FAST'>('NORMAL');
    size = input<'SMALL' | 'NORMAL'>('NORMAL');
    inline = input(false);

    readonly duration = computed(() => {
        switch (this.fadeSpeed()) {
            case 'FAST':
                return 0.5;
            case 'NORMAL':
                return 2;
        }
    });

    readonly containerClasses = computed(() => {
        const baseClasses = 'text-primary';
        return this.size() === 'SMALL'
            ? `${baseClasses} d-inline-flex align-items-center mx-2`
            : `${baseClasses} my-5 text-center`;
    });

    readonly containerWidth = computed(() => (this.size() === 'SMALL' ? 'auto' : '100%'));

    readonly spinnerClasses = computed(() =>
        this.size() === 'SMALL' ? 'spinner-border spinner-border-sm' : 'spinner-border',
    );

    @HostBinding('style.display')
    protected get display(): string | null {
        return this.inline() ? 'contents' : null;
    }
}
